var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('fiexdHeader'),_c('sideMenu'),_c('mainContent',[_c('router-view',{staticClass:"main"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }